import PropTypes from "prop-types";
import React from "react";

import DownloadFileButton from "@/components/DownloadFileButton";
import AppBarButtonWrapper from "@/components/AppBarButtonWrapper";

const WeldMapsButtons = ({ filters, loading }) => {
  return (
    <AppBarButtonWrapper showSpinner={loading}>
      <DownloadFileButton
        loading={loading}
        urlEndpoint={`${import.meta.env.VITE_VTS_API}/v1/weld_maps`}
        filename="Weld Maps"
        fileExtension="csv"
        filters={filters}
      />
    </AppBarButtonWrapper>
  );
};

WeldMapsButtons.propTypes = {
  // parsed url params
  filters: PropTypes.object,
  loading: PropTypes.bool,
};

export default WeldMapsButtons;
